<div class="loading container" *ngIf="product === undefined">
  <lib-loading></lib-loading>
</div>

<ng-container *ngIf="product !== undefined">

  <app-product-description [data]="product" [sku]="sku" [hideDescription]="hideDescription" [condition]="product.condition">
  </app-product-description>

  <app-product-features [data]="product" [hideCondoFeatures]="hideCondoFeatures" [hideRealtyFeatures]="hideRealtyFeatures">
  </app-product-features>

  <app-product-architect [data]="product" *ngIf="featureProductServices && product.condition === 'lançamento' && product.landscaper.realties">
  </app-product-architect>

  <app-product-landscaper [data]="product" *ngIf="featureProductServices && product.condition === 'lançamento' && product.landscaper.realties">
  </app-product-landscaper>

  <app-product-contacts [data]="product" [condition]="product.condition" *ngIf="product.condition === 'Pronto'">
  </app-product-contacts>

  <app-product-prices [data]="product" *ngIf="featureProductServices && product.condition === 'lançamento'">
  </app-product-prices>

  <app-product-proposals [data]="product" *ngIf="featureProductServices && product.condition === 'Pronto'">
  </app-product-proposals>

  <app-product-models [data]="product" *ngIf="product.condition === 'lançamento'">
  </app-product-models>

  <app-product-neighborhood [data]="product" *ngIf="featureProductServices && product.neighborhood">
  </app-product-neighborhood>

  <app-product-support-material [data]="product" *ngIf="featureProductServices && product.support_materials">
  </app-product-support-material>

  <app-product-sold-units [data]="product" *ngIf="featureProductServices && product.condition === 'lançamento'">
  </app-product-sold-units>

  <app-product-sales-blueprint [data]="product" *ngIf="featureProductServices && product.condition === 'lançamento'">
  </app-product-sales-blueprint>

</ng-container>